import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    spacing: 5
  },
  image: {
    backgroundImage: 'url(https://source.unsplash.com/random)',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: 'grey',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },


  title: {
    fontFamily: "Roboto Condensed",
    fontWeight: theme.typography.fontWeightBold
  },
  subtitle: {
    fontFamily: "Roboto Condensed",
  },
  content: {
    fontFamily: "Ubuntu",
  },
  changa: {
    fontFamily: "Changa",
    fontWeight: 'bold'
  },
}));

export default function SignIn() {

  const classes = useStyles();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();


  const [key, setKey] = useState('aNaLItics')

  const signin = async () => {
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_HOST}/signin`, { key })
      document.cookie = `token=${data}`
      enqueueSnackbar("Login success", { variant: 'success' });
      history.push('/')

    } catch (error) {
      enqueueSnackbar("Error loging in", { variant: 'error' });
    }
  }

  return (<Grid container justify="center" component="main" className={classes.root}>
    <CssBaseline />
    <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5" className={classes.title}>
          Sign in
        </Typography>
        <div style={{ textAlign: "center" }}>
          <Input type='password' placeholder='Key' onChange={(e) => { setKey(e.target.value) }} /><br />
          <Button onClick={signin}>Log in</Button>
        </div>
      </div>
    </Grid>

  </Grid>
  );

}